export default "__VITE_ASSET__19345df2__"